import { render, staticRenderFns } from "./tab-content.vue?vue&type=template&id=7d5e461d&scoped=true"
import script from "./tab-content.vue?vue&type=script&lang=js"
export * from "./tab-content.vue?vue&type=script&lang=js"
import style0 from "./tab-content.vue?vue&type=style&index=0&id=7d5e461d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5e461d",
  null
  
)

export default component.exports